import type {UserFeedback} from '../types'

export const toFeedbackRequestBodyAuth = (userFeedback: UserFeedback, deliveryId: string) => {
  const {score, comment, reasonIDs} = userFeedback
  const reasons = reasonIDs?.map(reasonID => ({reason_id: reasonID}))

  return {delivery_id: deliveryId, score, comment, reasons}
}
